import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { CREATE_PILLS_REMINDER } from '@app/constants/pillsReminders/pillsReminders'
import Api from '@app/api/pillsReminders/createPillsReminder'
import { history } from '@app/store/history'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'
import { PILLS_REMINDERS } from '@app/constants/routes'

const createPillsReminder = createLogic({
  type: CREATE_PILLS_REMINDER,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(CREATE_PILLS_REMINDER))
    try {
      await Api.createPillsReminder(action.accessToken, action.reminderData)
      history.push(PILLS_REMINDERS)
      dispatch(apiRequestDone(CREATE_PILLS_REMINDER))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('createPillsReminder failed without error')
      }
    }
    done()
  },
})

export default createPillsReminder
